export const ZIP_CODE_REGEX = /^\d{5}(\d{4})?$/;
export const ZIP_CODE_EXAMPLE = 'XXXXX or XXXXX-XXXX';
